var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.datetypes=='linear')?_c('div',{ref:"sector",attrs:{"id":"sector1"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }